import styled, { css } from "styled-components";

export const ErrorMessage = styled.span(
  ({ theme }) =>
    css`
      color: ${theme.color.fg.danger};
      font: ${theme.font.body.xs.medium};
    `
);
